module.exports = __webpack_public_path__ + "static/avocados-bacb91ea50b630915bc40d66923ad6b3.jpg";